export const BRAND_CHART_COLORS = [
  "#D67C2C",
  "#1D3469",
  "#e89d4f",
  "#4a6fa5",
  "#c06a25",
  "#2d4a7a",
  "#f5c882",
  "#8da8c8",
];

export const MONTHS = [
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
];

export const INCOME_BASE_HEADERS = [
  "Class / Grade",
  "Section",
  "Total Students",
  "EWS Students",
  "EWS Pay %",
  "Waiver Students",
  "Waiver %",
  "Tuition Income",
  "Admission Income",
  "Development Income",
  "Transport Income",
  "Exam Income",
  "Activity Income",
  "Other Income",
  "Annual Income Heads",
];

export const INCOME_END_HEADERS = [
  "Collection %",
  "Amount Collected",
  "Pending Due",
  "Income Billed",
  "Income Collected",
  "Avg Income",
  "Action",
];

export const EXPENSE_CATEGORIES = [
  ["Salary & Staff Cost", "Teacher Salaries", "Subject teachers, mother teachers, coordinators"],
  ["Salary & Staff Cost", "Leadership Salaries", "Principal, vice principal, academic heads, HODs"],
  ["Salary & Staff Cost", "Admin Staff Salaries", "Reception, accounts, admission counsellor, office staff"],
  ["Salary & Staff Cost", "Support Staff Salaries", "Peons, helpers, housekeeping, gardeners"],
  ["Salary & Staff Cost", "Security Staff Salaries", "Guards, gate staff, night security"],
  ["Salary & Staff Cost", "Transport Staff Salaries", "Drivers, conductors, bus attendants"],
  ["Salary & Staff Cost", "Visiting/Part-Time Staff", "Sports coach, music teacher, dance teacher, counsellor, trainer"],
  ["Academic & Learning Cost", "Curriculum Material", "Lesson plans, worksheets, teaching aids, academic resources"],
  ["Academic & Learning Cost", "Exam & Assessment Cost", "Question papers, answer sheets, printing, evaluation"],
  ["Academic & Learning Cost", "Lab Consumables", "Science chemicals, practical kits, robotics/AI kits"],
  ["Academic & Learning Cost", "Library Expenses", "Books, journals, magazines, digital library subscriptions"],
  ["Academic & Learning Cost", "Student Activity Material", "Charts, stationery, project material, classroom activity items"],
  ["Academic & Learning Cost", "Teacher Training", "Workshops, certifications, CPD programs"],
  ["Infrastructure & Maintenance", "Building Rent/Lease", "Rent or lease payment if school property is not owned"],
  ["Infrastructure & Maintenance", "Building Maintenance", "Repairs, painting, seepage, flooring, roofing"],
  ["Infrastructure & Maintenance", "Classroom Maintenance", "Benches, boards, fans, lights, minor repairs"],
  ["Infrastructure & Maintenance", "Furniture Repair/Replacement", "Desks, chairs, cupboards, shelves"],
  ["Infrastructure & Maintenance", "Electrical Maintenance", "Wiring, switches, lights, fans, AC service"],
  ["Infrastructure & Maintenance", "Plumbing Maintenance", "Taps, toilets, drainage, water pipelines"],
  ["Infrastructure & Maintenance", "Housekeeping & Cleaning", "Cleaning staff, cleaning material, sanitizers"],
  ["Infrastructure & Maintenance", "Garden/Landscaping", "Plants, grass, gardener, watering"],
  ["Infrastructure & Maintenance", "AMC Contracts", "AC, CCTV, computers, RO, generator, lift maintenance"],
  ["Utilities", "Electricity Bill", "Lights, fans, ACs, computers, labs, smart classes"],
  ["Utilities", "Water Bill", "Municipal water, borewell, tanker, water supply maintenance"],
  ["Utilities", "Internet Bill", "Broadband, leased line, backup internet"],
  ["Utilities", "Generator Fuel", "Diesel/petrol for power backup"],
  ["Utilities", "Waste Disposal", "Garbage pickup, sanitation disposal"],
  ["Technology & Digital Systems", "School ERP/LMS", "Fee management, attendance, report cards, parent app"],
  ["Technology & Digital Systems", "Website Maintenance", "Hosting, domain, updates, redesign"],
  ["Technology & Digital Systems", "Software Licenses", "Antivirus, MS Office, Google Workspace, Zoom, design tools"],
  ["Technology & Digital Systems", "Smart Class Expenses", "Smart panels, projectors, speakers, digital content subscription"],
  ["Technology & Digital Systems", "Computer Lab Maintenance", "Hardware repair, upgrades, keyboard, mouse, accessories"],
  ["Technology & Digital Systems", "CCTV Maintenance", "Cameras, DVR/NVR, storage, monitoring setup"],
  ["Technology & Digital Systems", "Biometric/RFID Systems", "Staff attendance, student ID cards, RFID cards"],
  ["Technology & Digital Systems", "Data Security", "Backup, firewall, cybersecurity tools"],
  ["Student Welfare & Support", "Medical Room", "First-aid kits, medicines, bed, nurse salary"],
  ["Student Welfare & Support", "Counselling Services", "Student counsellor, career counsellor, wellness support"],
  ["Student Welfare & Support", "Scholarships/Fee Waivers", "EWS, merit-based concession, staff-child concession"],
  ["Student Welfare & Support", "Student Insurance", "Accident or health insurance"],
  ["Student Welfare & Support", "ID Cards & Lanyards", "Student ID cards, RFID cards, lanyards"],
  ["Sports & Co-Curricular", "Sports Equipment", "Balls, bats, nets, cones, mats, indoor games"],
  ["Sports & Co-Curricular", "Sports Coach Salary", "PT teacher, external sports coaches"],
  ["Sports & Co-Curricular", "Annual Function", "Stage, sound, lights, costumes, decoration"],
  ["Sports & Co-Curricular", "Competitions", "Registration fees, travel, inter-school events"],
  ["Sports & Co-Curricular", "Cultural Activities", "Music, dance, art material, club activities"],
  ["Sports & Co-Curricular", "Educational Trips", "Transport, tickets, guides, permissions"],
  ["Transport", "Fuel Cost", "Diesel, petrol, CNG for school buses/vans"],
  ["Transport", "Bus Maintenance", "Servicing, tyres, battery, spare parts"],
  ["Transport", "Bus Insurance", "Vehicle insurance premium"],
  ["Transport", "GPS & Camera Cost", "GPS tracking, CCTV, speed governor"],
  ["Transport", "Permit & Fitness", "Road tax, fitness certificate, permits"],
  ["Transport", "Third-Party Transport Payment", "Payment to outsourced bus/van vendor"],
  ["Safety, Security & Compliance", "Fire Safety", "Fire extinguishers, refilling, alarms, drills"],
  ["Safety, Security & Compliance", "Safety Audits", "Building safety, electrical safety, fire audit"],
  ["Safety, Security & Compliance", "Compliance Certificates", "Fire NOC, sanitation certificate, building safety certificate"],
  ["Safety, Security & Compliance", "Disaster Management", "Emergency signage, evacuation maps, mock drills"],
  ["Safety, Security & Compliance", "Legal Compliance", "Affiliation, recognition, labour compliance"],
  ["Marketing & Admissions", "Digital Marketing", "Google Ads, Facebook Ads, SEO"],
  ["Marketing & Admissions", "Social Media", "Content creation, reels, designs, posting"],
  ["Marketing & Admissions", "Print Marketing", "Flyers, brochures, hoardings, banners"],
  ["Marketing & Admissions", "Admission Campaigns", "Open house, counselling events, school visits"],
  ["Marketing & Admissions", "CRM/Lead Management", "Landing pages, enquiry forms, CRM tools"],
  ["Marketing & Admissions", "Branding", "Signboards, wall graphics, reception branding"],
  ["Finance & Loan Cost", "Loan EMI", "Building loan, bus loan, equipment loan"],
  ["Finance & Loan Cost", "Interest Cost", "Interest on loans or overdraft"],
  ["Finance & Loan Cost", "Insurance Premium", "Building, vehicle, student, staff insurance"],
  ["Finance & Loan Cost", "Taxes & Duties", "Property tax, municipal charges, statutory payments"],
  ["Finance & Loan Cost", "Bank Charges", "Payment gateway fees, cheque charges, transaction charges"],
  ["Professional & Admin Services", "Legal Fees", "Lawyer, legal documentation, compliance support"],
  ["Professional & Admin Services", "CA/Audit Fees", "Accounting, audit, tax filing"],
  ["Professional & Admin Services", "Consultancy Fees", "Academic, HR, marketing, IT, school improvement consultants"],
  ["Professional & Admin Services", "Office Stationery", "Files, registers, paper, envelopes, printer ink"],
  ["Professional & Admin Services", "Printing & Photocopy", "Circulars, forms, reports, notices"],
  ["Capital Expenditure", "New Building Construction", "New block, classrooms, labs, auditorium"],
  ["Capital Expenditure", "Classroom Setup", "Furniture, boards, smart panels, storage"],
  ["Capital Expenditure", "Lab Setup", "Science lab, computer lab, AI/STEM/robotics lab"],
  ["Capital Expenditure", "Playground Development", "Courts, turf, play equipment"],
  ["Capital Expenditure", "Bus Purchase", "New school buses or vans"],
  ["Capital Expenditure", "Solar Installation", "Solar panels, inverter, battery backup"],
  ["Capital Expenditure", "Major Renovation", "Reception, washrooms, auditorium, façade"],
  ["Hidden/Indirect Cost", "Fee Collection Loss", "Pending fees, bad debts, discounts"],
  ["Hidden/Indirect Cost", "Staff Turnover Cost", "Hiring and training new staff"],
  ["Hidden/Indirect Cost", "Low Enrolment Cost", "Empty seats while fixed expenses continue"],
  ["Hidden/Indirect Cost", "Underutilized Assets", "Empty labs, buses, classrooms, software"],
  ["Hidden/Indirect Cost", "Parent Complaint Handling", "Refunds, service recovery, extra admin time"],
];

export const UNIQUE_EXPENSE_CATEGORIES = [
  ...new Set(EXPENSE_CATEGORIES.map((item) => item[0])),
];
